import React from 'react';
import { Box, Typography } from '@mui/material';

interface Honor {
  date: string;
  title: string;
  detail: string;
}

export const Awards: React.FC = () => {
  const honors: Honor[] = [
    {
      date: '2017',
      title: 'Speaker, NVIDIA GTC Europe (Munich)',
      detail: 'Visualizing and Interrogating Black Box AI Models with GPU Enabled Architecture'
    },
    {
      date: '2014',
      title: 'Helmholtz-Fonds e.V. Dissertation Award',
      detail: 'Helmholtz Association, for an outstanding doctoral dissertation in mechanical engineering'
    }
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography sx={{
        mb: 1.5,
        color: '#00D4FF',
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: '15px',
        fontWeight: 600
      }}>
        Honors & Talks
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 1 }}>
        {honors.map((h) => (
          <Box
            component="li"
            key={h.title}
            sx={{ display: 'grid', gridTemplateColumns: '56px 1fr', gap: 2, alignItems: 'baseline' }}
          >
            <Typography sx={{ color: '#78909C', fontFamily: '"JetBrains Mono", monospace', fontSize: '13px' }}>
              {h.date}
            </Typography>
            <Typography component="div" sx={{ fontSize: '14px', color: '#B0BEC5', lineHeight: 1.6 }}>
              <Box component="span" sx={{ color: '#FFFFFF', fontWeight: 500 }}>{h.title}</Box>
              {' · '}{h.detail}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
